const NO_SUBCAT_ID = 'aint-no-subcats-here';

export const getNullSubcatsId = (categoryId) => `${categoryId}-${NO_SUBCAT_ID}`; // Append some suffix to the parent category ID to represent the "No subcategory" option

export const byCategory = (categories) => (link) => {
  if (!categories.length) return true;

  // Show only if the link has every selected category/subcategory
  return categories.every((selectedCat) => {
    return link.categories.some((linkCat) => {
      const { id, subcategories } = linkCat;

      const nullSubcatsSelected = selectedCat === getNullSubcatsId(id); // User has explicitly selected the "No subcategory" option
      const hasNoSubcats = !subcategories.length;

      return (
        selectedCat === id ||
        (nullSubcatsSelected && hasNoSubcats) ||
        subcategories?.some((linkSubcat) => {
          return selectedCat === linkSubcat.id;
        })
      );
    });
  });
};
